import { actSlice } from './act'
import { actUnpaidSlice } from './actUnpaid'
import { actStatusesSlice } from './actStatuses'

export const actsSlice = {
	[actSlice.name]: actSlice.reducer,
	[actUnpaidSlice.name]: actUnpaidSlice.reducer,
	[actStatusesSlice.name]: actStatusesSlice.reducer,
}

export * from './act'
export * from './actUnpaid'
export * from './actStatuses'
